import React, { useCallback } from 'react';
import {
	Control,
	FieldValues,
	UseFormSetValue,
	UseFormWatch,
} from 'react-hook-form';

import { Label, ModalSelect, Select } from '@components/common';

import { TSelectOption } from '@interfaces/components/componentTypes';
import { IModalSelectOption } from '@components/common/ModalSelect/ModalSelect.types';

import { EParametersFormValues } from '../../enums';

import styles from '../HistoryCheckOptions.module.scss';

interface IHistoryCheckDefaultOptions {
	technologiesOptions: TSelectOption[];
	nodeTypesOptions: TSelectOption[];
	siteIdsOptions: IModalSelectOption[];
	control: Control;
	watch: UseFormWatch<FieldValues>;
	setValue: UseFormSetValue<FieldValues>;
	isLoading: boolean;
	isMavenir: boolean;
}

const HistoryCheckDefaultOptions = ({
	technologiesOptions,
	nodeTypesOptions,
	siteIdsOptions,
	control,
	watch,
	setValue,
}: IHistoryCheckDefaultOptions) => {
	const onChangeSites = useCallback((values: Array<IModalSelectOption>) => {
		setValue(EParametersFormValues.siteIds, values);
	}, [setValue]);

	const isTechnologyDisabled = !watch(EParametersFormValues.vendor);
	const isNodeTypeDisabled = !watch(EParametersFormValues.technology);
	const isSitesModalDisabled = !watch(EParametersFormValues.nodeType) || !siteIdsOptions.length;

	return (
		<>
			<div className={styles.groupOptions}>
				<Select
					control={control}
					disabled={isTechnologyDisabled}
					label='Technology'
					name={EParametersFormValues.technology}
					options={technologiesOptions}
					placeholder='Select technology'
					required
				/>
				<Select
					control={control}
					disabled={isNodeTypeDisabled}
					label='Node type'
					name={EParametersFormValues.nodeType}
					options={nodeTypesOptions}
					placeholder='Select node type'
					required
				/>
			</div>
			<div>
				<Label
					className={styles.sitesLabel}
					label='Sites'
					required
				/>
				<ModalSelect
					disabled={isSitesModalDisabled}
					label='Select sites'
					modalLabel='Select sites'
					onChange={onChangeSites}
					options={siteIdsOptions}
					searchPlaceholder='Search by site ID'
					values={watch(EParametersFormValues.siteIds)}
				/>
			</div>
		</>
	);
};

export default HistoryCheckDefaultOptions;
